import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnablePackingSlipPackageSections = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enablePackingSlipPackageSections);
};
